/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { MediaImageDestroyPathParams, MediaImageDestroyResponse } from '../types/MediaImageDestroy'

/**
 * DELETE /media/:organisation/:media
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::destroy
 */
export async function mediaImageDestroy(
	organisation: MediaImageDestroyPathParams['organisation'],
	media: MediaImageDestroyPathParams['media'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageDestroyResponse>> {
	return axiosInstance.delete(`/media/${organisation}/${media}`, config)
}
